import React from 'react';
import ChatView from '../chat/ChatView';
import HistoryView from '../history/HistoryView';
import FaqView from '../faq/FaqView';

/**
 * 활성 탭에 따라 각 테마(채팅, 역사, FAQ) 화면을 렌더링하는 콘텐츠 컨테이너.
 */
const InquiryTabContent = ({
    activeTab,
    viewMode,
    currentUser,
    messages,
    isAiTyping,
    isSessionLoading,
    messagesEndRef,
    completedTypingIds,
    handleComplete,
    historyProps,
    onDeleteInquiry,
    onSelectInquiry
}) => {
    return (
        <div className="max-w-4xl mx-auto flex-1 flex flex-col min-h-0 overflow-hidden w-full">
            {/* 채팅 탭 (메시지 보더 등) */}
            {activeTab === 'chat' && (
                <div className={`flex-1 flex flex-col space-y-2 pb-0 pt-1 min-h-0 ${messages.length === 0 ? 'overflow-y-hidden' : 'overflow-hidden'}`}>
                    <ChatView
                        messages={messages}
                        isAiTyping={isAiTyping}
                        isSessionLoading={isSessionLoading}
                        currentUser={currentUser}
                        messagesEndRef={messagesEndRef}
                        completedTypingIds={completedTypingIds}
                        handleComplete={handleComplete}
                    />
                </div>
            )}

            {/* 질의 현황 관리 탭 (독립 스크롤) */}
            {activeTab === 'history' && (
                <div className="flex-1 overflow-y-auto px-1 custom-scrollbar">
                    <HistoryView
                        viewMode={viewMode}
                        currentUser={currentUser}
                        {...historyProps}
                        onDeleteInquiry={onDeleteInquiry}
                        onSelectInquiry={onSelectInquiry}
                    />
                </div>
            )}

            {/* 자주 묻는 질문 탭 (독립 스크롤) */}
            {activeTab === 'faq' && (
                <div className="flex-1 overflow-y-auto px-1 custom-scrollbar">
                    <FaqView />
                </div>
            )}
        </div>
    );
};

export default InquiryTabContent;
